import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, withCredentials: true });

export const saveScore = (payload) => http.post("/scores", payload).then((r) => r.data);
export const fetchScores = (difficulty) => http.get("/scores", { params: { difficulty } }).then((r) => r.data);
export const fetchMe = () => http.get("/auth/me").then((r) => r.data);
export const exchangeSession = (session_id) => http.post("/auth/session", { session_id }).then((r) => r.data);
export const logout = () => http.post("/auth/logout").then((r) => r.data);
export const deleteAccount = () => http.delete("/auth/account").then((r) => r.data);

export const formatTime = (ms) => {
  const m = Math.floor(ms / 60000);
  const s = Math.floor((ms % 60000) / 1000);
  const cs = Math.floor((ms % 1000) / 10);
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}.${String(cs).padStart(2, "0")}`;
};
